import { render, staticRenderFns } from "./Branch classification.vue?vue&type=template&id=07a947a1"
import script from "./Branch classification.vue?vue&type=script&lang=js"
export * from "./Branch classification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports